import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/serviceType-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { IServiceType } from 'src/types/service-types';
import ServiceTypeActionsColumn from './ServiceTypeActionsColumn';
import { QueryParams } from 'src/types/grid';
import { CellProps } from 'react-table';
import { ISeance } from '../../../../../../../types/seance';
import dropDownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import { IAdminWork } from '../../../../../../../types/adminWork';

interface Props {
    data: Paginated<IServiceType>;
    getData: (params: QueryParams) => void;
    providers: SelectObject[];
}

//const columns: Column<IServiceType>[] = [
const getColumns = (dataProd: SelectObject[]): Column<IServiceType>[] => [
    {
        Header: 'Name',
        accessor: 'title',
        Filter: textFilter<IServiceType>(),
    },
    {
        Header: 'CPT',
        accessor: 'cpt',
        Filter: textFilter<IServiceType>(),
    },
    {
        Header: 'Actions',
        accessor: 'id',
        Cell: ServiceTypeActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const ServiceTypesGrid: React.FunctionComponent<Props> = ({ data, getData, providers }: Props) =>
{
    const [columns, setColumns] = useState<any>([]);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers));
    }
    return (
        <div className={classNames(styles.grid)}>
            <Grid<IServiceType> columns={columns} data={data} getData={getData} />
        </div>
    );
};

export default ServiceTypesGrid;
